const Heading = {
  baseStyle: {
    fontWeight: '500',
  },
};

export default Heading;
